import { render, staticRenderFns } from "./ServiceOptions.vue?vue&type=template&id=bf865018&scoped=true&"
import script from "./ServiceOptions.vue?vue&type=script&lang=js&"
export * from "./ServiceOptions.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOptions.vue?vue&type=style&index=0&id=bf865018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf865018",
  null
  
)

export default component.exports